import {FlexLockStatusRequest, FlexVABGetLockStatusQuery} from "../../autogenerated/ZoomBridge";

export default class GetLockStatusQuery {
  constructor() {
  }

  run(filePaths, dirFuids) {
    return new Promise((onSuccess, onFailure) => {
      const req:FlexLockStatusRequest = new FlexLockStatusRequest;
      req._filePaths = filePaths;
      req._dirFuids = dirFuids;

      const query = new FlexVABGetLockStatusQuery();
      query.message = req;
      query.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (failedResp) => {
          onFailure(failedResp);
        }
      );
    });
  }

}